import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconWorkspace(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm2 1v4h14V5H5ZM3 14a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6Zm2 1v4h4v-4H5Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M13 14a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1ZM14 16a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6ZM13 20a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Z"
      />
    </BaseIcon>
  );
}
